// Mock data for Phantom Trades platform

export const mockCryptos = [
  {
    id: 'bitcoin',
    symbol: 'BTC',
    name: 'Bitcoin',
    current_price: 43250.50,
    price_change_percentage_24h: 2.45,
    market_cap: 845000000000,
    total_volume: 28500000000,
    image: 'https://assets.coingecko.com/coins/images/1/small/bitcoin.png'
  },
  {
    id: 'ethereum',
    symbol: 'ETH',
    name: 'Ethereum',
    current_price: 2280.75,
    price_change_percentage_24h: -1.23,
    market_cap: 274000000000,
    total_volume: 15200000000,
    image: 'https://assets.coingecko.com/coins/images/279/small/ethereum.png'
  },
  {
    id: 'binancecoin',
    symbol: 'BNB',
    name: 'BNB',
    current_price: 315.20,
    price_change_percentage_24h: 3.87,
    market_cap: 48500000000,
    total_volume: 1850000000,
    image: 'https://assets.coingecko.com/coins/images/825/small/bnb-icon2_2x.png'
  },
  {
    id: 'solana',
    symbol: 'SOL',
    name: 'Solana',
    current_price: 98.45,
    price_change_percentage_24h: 5.12,
    market_cap: 42000000000,
    total_volume: 2100000000,
    image: 'https://assets.coingecko.com/coins/images/4128/small/solana.png'
  },
  {
    id: 'ripple',
    symbol: 'XRP',
    name: 'XRP',
    current_price: 0.6234,
    price_change_percentage_24h: -0.89,
    market_cap: 33500000000,
    total_volume: 1450000000,
    image: 'https://assets.coingecko.com/coins/images/44/small/xrp-symbol-white-128.png'
  },
  {
    id: 'cardano',
    symbol: 'ADA',
    name: 'Cardano',
    current_price: 0.5123,
    price_change_percentage_24h: 1.45,
    market_cap: 18000000000,
    total_volume: 580000000,
    image: 'https://assets.coingecko.com/coins/images/975/small/cardano.png'
  }
];

export const mockUserPortfolio = {
  totalBalance: 125430.50,
  totalProfit: 18250.30,
  profitPercentage: 17.06,
  holdings: [
    {
      crypto: 'BTC',
      amount: 1.2345,
      value: 53380.24,
      profit: 8250.50,
      profitPercentage: 18.3
    },
    {
      crypto: 'ETH',
      amount: 15.6789,
      value: 35750.12,
      profit: 5430.20,
      profitPercentage: 17.9
    },
    {
      crypto: 'SOL',
      amount: 250.45,
      value: 24650.80,
      profit: 3120.45,
      profitPercentage: 14.5
    },
    {
      crypto: 'BNB',
      amount: 35.67,
      value: 11649.34,
      profit: 1449.15,
      profitPercentage: 14.2
    }
  ]
};

export const mockTransactions = [
  {
    id: '1',
    type: 'buy',
    crypto: 'BTC',
    amount: 0.5,
    price: 43180.00,
    total: 21590.00,
    date: '2025-01-15T10:30:00Z',
    status: 'completed'
  },
  {
    id: '2',
    type: 'sell',
    crypto: 'ETH',
    amount: 2.5,
    price: 2275.50,
    total: 5688.75,
    date: '2025-01-14T15:45:00Z',
    status: 'completed'
  },
  {
    id: '3',
    type: 'buy',
    crypto: 'SOL',
    amount: 100,
    price: 97.80,
    total: 9780.00,
    date: '2025-01-13T09:20:00Z',
    status: 'completed'
  },
  {
    id: '4',
    type: 'deposit',
    crypto: 'USDT',
    amount: 10000,
    price: 1.00,
    total: 10000.00,
    date: '2025-01-12T14:15:00Z',
    status: 'completed'
  },
  {
    id: '5',
    type: 'withdraw',
    crypto: 'USDT',
    amount: 5000,
    price: 1.00,
    total: 5000.00,
    date: '2025-01-10T11:30:00Z',
    status: 'pending'
  }
];

export const mockStats = {
  activeUsers: '45,833+',
  dailyVolume: '$0.9M+',
  successRate: '89%'
};
